import { IncomingMessage } from 'http';
import { NextApiRequest, NextApiResponse } from 'next';

export enum AuthStatus {
  Loading = 'LOADING',
  User = 'USER',
  Anonymous = 'ANONYMOUS',
}

export const HASURA_CLAIMS_KEY = 'https://hasura.io/jwt/claims';
// This should actually be an enum?
export enum HasuraClaimKey {
  AllowedRoles = 'x-hasura-allowed-roles',
  DefaultRole = 'x-hasura-default-role',
  UserID = 'x-hasura-user-id',
  Subscriptions = 'x-hasura-subscriptions',
}

export interface HasuraClaims {
  [HasuraClaimKey.AllowedRoles]: string[];
  [HasuraClaimKey.DefaultRole]: string;
  [HasuraClaimKey.UserID]: string;
  // [HasuraClaimKey.Subscriptions]: string;
}

export interface CustomClaims {
  userId: string;
  [HASURA_CLAIMS_KEY]: HasuraClaims;
}

export enum Company {
  Facebook = 'facebook',
  Twitter = 'twitter',
  Google = 'google',
  Linkedin = 'linkedin',
  Discord = 'discord',
}

export interface IncomingMessageWithCookies extends IncomingMessage {
  cookies: {
    [key: string]: string;
  };
}

export const UNABLE_TO_OAUTH = {
  message: 'Unable to register your account using OAuth',
};

export enum OauthProvider {
  // Facebook = 'facebook',
  // Github = 'github',
  // Google = 'google',
  Discord = 'discord',
}

/**
 * Providers that sign in through a Firebase popup (hooks, linking modal, link-provider payload).
 * `apple` is reserved for a future implementation — it lives in the type so call sites are ready
 * for it, but no Apple button or flow is wired yet.
 *
 * CAVEAT: while only `google` + `facebook` are live, binary `provider === 'google' ? … : …`
 * checks are exhaustive and safe. Once Apple is actually wired, those ternaries silently map
 * `apple` → the Facebook branch — switch them to a map/switch at that point.
 */
export type FirebasePopupProvider = 'google' | 'facebook' | 'apple';

/** Value stored in users.latestAuthProvider / user_auth_identities.provider for VAIR sign-ins. */
export const VAIR_AUTH_PROVIDER_ID = 'vair';

/**
 * Every "Continue with …" button. `vair` is not a Firebase provider: it runs a server-side OAuth
 * redirect that ends in a Firebase custom token (services/client/vairSignIn), so the popup code
 * paths are typed on FirebasePopupProvider and can never receive it.
 */
export type SocialAuthProvider = FirebasePopupProvider | typeof VAIR_AUTH_PROVIDER_ID;

/** Human-readable label for each social provider. Exhaustive over SocialAuthProvider. */
export const SOCIAL_AUTH_PROVIDER_LABEL: Record<SocialAuthProvider, string> = {
  google: 'Google',
  facebook: 'Facebook',
  apple: 'Apple',
  vair: 'VAIR',
};

export type NextOauthApiHandler<T = any> = (
  req: NextApiRequest,
  res: NextApiResponse<T>,
  auth: any, // NOTE: Use union "|" if more providers are added
) => void | Promise<void>;

export interface StoredState {
  state: string;
  query?: string;
}

export const TEMP_FIREBASE_COOKIE = 'fbtoken';
